import apiRequest from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { setLoading } from 'utilities/redux.actions';

export default function* (action) {
    const {
        meta: { handleSubmit = () => { } },
        payload
    } = action;

    yield put(setLoading(true));

    try {
        const { data } = yield call(
            apiRequest,
            {
                url: 'designation/all',
                method: 'get'
            }
        );

        yield put(setLoading(false));
        return handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        console.error('Error fetching designations:', error);
    }
}
